import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const FAQ = () => {
    const [openFaq, setOpenFaq] = useState(null);

    const faqs = [
        {
            question: "How do online sessions work?",
            answer: "All sessions are conducted live via Google Meet or Zoom. We use interactive whiteboards to ensure students can follow along and collaborate in real-time."
        },
        {
            question: "What subjects and levels do you cover?",
            answer: "We specialize in the British Curriculum, covering major subjects including Maths, Sciences, and English for both GCSE and A-Level students."
        },
        {
            question: "How do payments and bookings work?",
            answer: "You can book sessions individually or purchase a package for a discount. All bookings are handled securely through our platform."
        },
        {
            question: "Can I reschedule or cancel a session?",
            answer: "Yes, we understand that plans change. You can reschedule or cancel any session free of charge with at least 24 hours' notice."
        }
    ];

    return (
        <section id="faq" className="section faq-section">
            <div className="section-header">
                <h2 className="section-title">
                    Frequently Asked <span className="highlight-yellow">Questions</span>
                </h2>
            </div>
            <div className="faq-list">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <button
                            className="faq-question"
                            onClick={() => setOpenFaq(openFaq === index ? null : index)}
                        >
                            <span>{faq.question}</span>
                            <FaChevronDown className={`faq-icon ${openFaq === index ? 'open' : ''}`} />
                        </button>
                        {openFaq === index && (
                            <div className="faq-answer">
                                <p>{faq.answer}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FAQ;
